module.exports = __webpack_public_path__ + "img/interest-2.453f6f84.png";